/**
 * Handles the disabling of submit elements while some actions are happening.
 * Actions are detected through events, with an `<eventName>:before`
 * marking the start of the action and an `<eventName>:complete` marking
 * its end.
 * @module embed/disable_while_loading
 */

import { delegate } from '@/lib/events';

const SELECTOR_FORM = '.js-bcs-form';
const SELECTOR_SUBMIT = '[type="submit"]';
export const CLASS_PREVENT_SUBMISSION = 'js-bcs-form--disabled';

/**
 * @param {Array<String>} eventNames The list of `<eventName>` marking events to listen to
 */
export function setupDisableWhileLoading(eventNames = []) {
  let pendingOperations = 0;
  eventNames.forEach(function(eventName) {
    document.addEventListener(
      `${eventName}:before`,
      delegate(SELECTOR_FORM, (event, delegateTarget) => {
        pendingOperations++;
        delegateTarget.classList.add(CLASS_PREVENT_SUBMISSION);
        Array.from(delegateTarget.querySelectorAll(SELECTOR_SUBMIT)).forEach(
          el => {
            el.disabled = true;
          }
        );
      })
    );
    document.addEventListener(
      `${eventName}:complete`,
      delegate(SELECTOR_FORM, (event, delegateTarget) => {
        pendingOperations--;
        if (pendingOperations < 1) {
          pendingOperations = 0;
          delegateTarget.classList.remove(CLASS_PREVENT_SUBMISSION);
          Array.from(delegateTarget.querySelectorAll(SELECTOR_SUBMIT)).forEach(
            el => {
              el.disabled = false;
            }
          );
        }
      })
    );
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/disable_while_loading.js